import styled from 'styled-components';
import {getRatingsColor} from '@stencil/hotels-utils/src/get-ratings-colors';
import {FlexWrap} from '../../../../../../stories/components/CommonStyleUtils/dwebCommon.styles';

export const DiningWrapper = styled.div(
  props => `
  width: 100%;
  margin-bottom:${props.theme.spacing.custom(16)};
`,
);
export const DiningLeftContainer = styled.div(
  props => `
  width: 55%;
  display:flex;
  align-items: center;
  & svg{
    min-width: ${props.theme.spacing.custom(36)};
  }
`,
);
export const DiningRightContainer = styled.div(
  props => `
  width: 50%;
  display:flex;
  align-items: center;
   & svg{
    min-width: ${props.theme.spacing.custom(36)};
  }
`,
);
export const DiningText = styled.span(
  props => `
  font-size: ${props.theme.font.custom(16)};
  margin-left:${props.theme.spacing.large}
`,
);
export const FullContainer = styled(FlexWrap)(
  props => `
  margin-bottom: ${props.theme.spacing.base};
`,
);
export const LightGreenWraper = styled.span(
  props => `
  background:#e9f6ea;
  width:3.6rem;
  height:3.6rem;
  border-radius:50%;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  display:flex;
`,
);
export const LightOrangeWraper = styled.span(
  props => `
  background:#fdf6e9;
  width:3.6rem;
  height:3.6rem;
  border-radius:50%;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  display: flex;
`,
);
export const FoodRatingWrapper = styled.ul(
  props => `
    display:flex;
    align-items: center;
    margin-bottom: ${props.theme.spacing.custom(25)};
    li{
        padding-right: ${props.theme.spacing.large};
        border-right: 1.7px solid rgba(10, 37, 73,0.5); 
        &:last-child {
            border-right:none;
        } 
        &:nth-child(2) {
            padding-left: ${props.theme.spacing.large};
        } 
    }
    `,
);
export const LowRatingSpan = styled.span(
  props => `
    background-color:${getRatingsColor(props.rating)};
    padding: ${props.theme.spacing.custom(2)} ${props.theme.spacing.small};
    border-radius: ${props.theme.misc.borderRadius.custom(4)};
    margin-right: ${props.theme.spacing.base};
    color: ${props.theme.colors.goWhite.base};
    font-size: ${props.theme.font.custom(18)};
    `,
);
export const RatingNumberSpan = styled.span(
  props => `
  font-weight: 600;
      `,
);
export const AmbienceSpan = styled.span(
  props => `
  font-weight: 600;
  font-size: ${props.theme.font.custom(18)};
    `,
);

export const RestaurantName = styled.p(
  props => `
  font-weight: 600;
  font-size: ${props.theme.font.custom(18)};
  margin: 0  0 15px;
  `,
);

//// Yes, I know this is a duplicate of the above, but it's a lot easier to read this way.

export const FirstFullContainer = styled(FlexWrap)(
  props => `
  border-bottom:1px solid #eef4fd;
  margin-bottom: ${props.theme.spacing.large};
  padding: ${props.theme.spacing.custom(18)};
`,
);
export const SecondFullContainer = styled(FlexWrap)(
  props => `
    margin-bottom: ${props.theme.spacing.large};
    padding: 0 ${props.theme.spacing.custom(18)};
  `,
);
